import { render } from "./wfm-toolbar.vue?vue&type=template&id=4e2f0783"
import script from "./wfm-toolbar.vue?vue&type=script&lang=js"
export * from "./wfm-toolbar.vue?vue&type=script&lang=js"

import "./wfm-toolbar.vue?vue&type=style&index=0&id=4e2f0783&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__